"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSongwriterCatalogSelectionCriteria = void 0;
const catalog_search_store_1 = require("@App/stores/search/catalog-search-store");
const mobx_1 = require("mobx");
const calc_num_pages_1 = require("@App/helpers/pagination/calc-num-pages");
const songwriter_1 = require("@App/api/routes/songwriter/songwriter");
const convert_new_search_terms_1 = require("@App/helpers/convert-new-search-terms");
const sidebar_download_type_1 = require("@App/enum/sidebar-download-type");
const search_criteria_store_1 = __importDefault(require("@App/stores/search/search-criteria-store"));
const get_search_query_1 = require("@App/helpers/get-search-query");
const search_option_type_1 = require("@App/enum/search-option-type");
const required_criteria_1 = require("@App/enum/required-criteria");
exports.defaultSongwriterCatalogSelectionCriteria = [
    {
        id: get_search_query_1.SEARCH_SONGWRITER_CATALOG_WORK_OPTIONS[0].id,
        selectedOption: get_search_query_1.SEARCH_SONGWRITER_CATALOG_WORK_OPTIONS[0],
        searchTerm: '',
        isFixed: true,
    },
    {
        id: get_search_query_1.SEARCH_SONGWRITER_CATALOG_WORK_OPTIONS[1].id,
        selectedOption: get_search_query_1.SEARCH_SONGWRITER_CATALOG_WORK_OPTIONS[1],
        searchTerm: '',
        isFixed: true,
    },
];
class SongwriterCatalogSearchStore extends catalog_search_store_1.CatalogSearchStore {
    getWorksRightsHolder(pagination, search) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield (0, songwriter_1.searchSongwriterCatalog)(this.rootStore.songwriterStore.currentSongwriterId, pagination, search ? (0, convert_new_search_terms_1.convertNewSearchTerms)(search) : {});
                (0, mobx_1.runInAction)(() => {
                    this._worksRightsHolder = {
                        count: response.data.totalElements,
                        works: response.data.content,
                        error: undefined,
                    };
                    if (pagination.limit && pagination.page && response) {
                        const data = (0, calc_num_pages_1.calcNumPages)(response.data.totalElements, pagination.limit, pagination.page);
                        if (!data) {
                            return;
                        }
                        this._worksRightsHolderPaginationInfo = data;
                    }
                });
            }
            catch (e) {
                this.rootStore.popupStore.setAlertFromError(e);
            }
        });
    }
    get sidebarDownloadType() {
        return sidebar_download_type_1.SidebarDownloadType.SongwriterCatalogExport;
    }
    resetSearchCriteriaStore() {
        const maxCriteria = 6;
        this.searchCriteriaStore = new search_criteria_store_1.default(exports.defaultSongwriterCatalogSelectionCriteria, get_search_query_1.SEARCH_SONGWRITER_CATALOG_WORK_OPTIONS, search_option_type_1.SearchOptionType.primary, required_criteria_1.RequiredCriteria.primaryFilter, maxCriteria, []);
    }
}
exports.default = SongwriterCatalogSearchStore;
